// session-naming.ts — rules for when auto-namer updates may clobber a local
// name. Ported from the Companion ws.ts:865-874 regex gate: the backend's
// Haiku-based auto-namer emits 3-6 word titles once, and we only want that to
// overwrite the UI copy if the user hasn't manually renamed the session yet.
//
// The current auto-namer emits lowercase phrases; the gate also covers
// Companion's legacy "Adj Noun" placeholder so older rows migrate cleanly.

const PLACEHOLDER_ADJ_NOUN = /^[A-Z][a-z]+ [A-Z][a-z]+$/;
const PLACEHOLDER_LOWERCASE_WORDS = /^[a-z0-9]+(?: [a-z0-9]+){2,5}$/;

/** True when the given name looks auto-generated (not user-authored). */
export function isAutoNamerPlaceholder(name: string | undefined | null): boolean {
	if (!name) return true;
	const trimmed = name.trim();
	if (!trimmed) return true;
	return PLACEHOLDER_ADJ_NOUN.test(trimmed) || PLACEHOLDER_LOWERCASE_WORDS.test(trimmed);
}
